import { takeEvery, put } from 'redux-saga/effects';
import mealActions from '../actionTypes/mealActions';
import { API_CALL } from '../actionTypes/sharedActions';
import { GET_MEAL_DETAILS } from '../routes';

function* getMealDetails({ payload }) {
  const { id } = payload;

  yield put({
    type: API_CALL,
    payload: {
      url: GET_MEAL_DETAILS.replace(':id', id),
      method: 'GET',
      data: payload,
    },
    successAction: mealActions.getMealDetailsSuccess,
    failureAction: mealActions.getMealDetailsFailed,
  });
}

export default function* watchGetMealDetails() {
  yield takeEvery(mealActions.getMealDetails, getMealDetails);
}
